(function () {
  function onReady() {
    var container = document.querySelector('.mayi-float-actions');
    var upBtn = document.querySelector('[data-mayi-scroll-up]');
    var downBtn = document.querySelector('[data-mayi-scroll-down]');
    if (!upBtn && !downBtn) return;

    if (upBtn) {
      upBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
    if (downBtn) {
      downBtn.addEventListener('click', function () {
        window.scrollBy({ top: window.innerHeight * 0.9, behavior: 'smooth' });
      });
    }

    var ticking = false;
    var hideTimer = null;

    function updateHiddenState() {
      var scrollY = window.scrollY || window.pageYOffset;
      var atTop = scrollY < 200;
      var atBottom =
        window.innerHeight + scrollY >= document.documentElement.scrollHeight - 80;

      if (upBtn) upBtn.hidden = atTop;
      if (downBtn) downBtn.hidden = atBottom;
    }

    function revealWhileScrolling() {
      if (!container) return;
      container.classList.add('is-scrolling');
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        container.classList.remove('is-scrolling');
      }, 1200);
    }

    function onScroll() {
      updateHiddenState();
      revealWhileScrolling();
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(onScroll);
          ticking = true;
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', updateHiddenState);

    // État initial : on calcule seulement quel bouton est pertinent
    // (haut/bas de page), sans les rendre visibles tant qu'on n'a pas
    // encore scrollé — ils ne doivent apparaître qu'au scroll actif.
    updateHiddenState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
